module.exports = __webpack_public_path__ + "static/media/sa.eba985d6.svg";